import { BaseCustomerSurveyClient, User } from "@core/types";
import { supabaseClient } from "../supabase";
import { SupaCustomerSurveyCompletionsType } from "../types/supabaseFragments";
import { convertSupaCustomerSurvey } from "./converters";

class CustomerSurveyClient extends BaseCustomerSurveyClient {
  async createCustomerSurveyAnswers(
    payload: Omit<SupaCustomerSurveyCompletionsType, "id" | "created_at">
  ): Promise<void> {
    await supabaseClient.from("customer_survey_completions").insert(payload);
  }
  async getCustomerSurveyAnswers(userPhone: User["phone"]): Promise<SupaCustomerSurveyCompletionsType | null> {
    const { data: customerSurveyAnswers } = await supabaseClient
      .from("customer_survey_completions")
      .select()
      .eq("user_phone", userPhone!)
      .maybeSingle()
      .throwOnError();

    return !!customerSurveyAnswers
      ? convertSupaCustomerSurvey(customerSurveyAnswers as SupaCustomerSurveyCompletionsType)
      : null;
  }
}

export default CustomerSurveyClient;
